@if (!hasAdditionalImages()) {
  @for (s of thumbnailSliders; track s) {
    <carousel
      #thumbnailCarousel="carousel"
      [cellsToShow]="s.value"
      [lightDOM]="true"
      [objectFit]="'cover'"
      class="{{ s.css + ' ' + (prefix + s.id) }} thumbnailCarousel"
      >
      @for (
        additionalImage of additionalImagesInCorrectOrder(); track
        additionalImage; let i = $index) {
        <div
          class="carousel-cell"
          >
          <div
            (click)="goToSlide(i)"
            [description]="getImageAltTitle(i, false)"
            [imageFormat]="imageFormat"
            [image]="additionalImage"
            class="product-detail_thumbnail-image"
            render-product-image
          ></div>
        </div>
      }
    </carousel>
  }
}
